import React, { Fragment } from 'react';
import { api } from '../api';
import { Button, Form, ListGroup, Image } from 'react-bootstrap';
import ReactStars from "react-rating-stars-component";
import { Spacer } from './Helpers';
import { S3ImageUpload } from './ImageUploader';
import { getCloudinaryUrlFromKey } from './Helpers';
import {ReactComponent as WholeUncookedDonut} from '../WholeUncookedDonut.svg';
import {ReactComponent as WholeDonut} from '../WholeDonut.svg';
import {ReactComponent as HalfIcedDonut} from '../HalfIcedDonut.svg';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


function ReviewRater(props) {
    const ratingChanged = (newRating) => {
        props.onChange(newRating * 2);
    };

    return (
        <Fragment>
            <p style={{marginBottom: "0px"}}>Rating</p>
            <ReactStars
                count={5}
                onChange={ratingChanged}
                size={36}
                isHalf={true}
                emptyIcon={<WholeUncookedDonut width="36px" opacity=".75" />}
                halfIcon={<HalfIcedDonut width="36px"/>}
                filledIcon={<WholeDonut width="36px"/>}
            />
        </Fragment>
    );
}

function resolveVendorId(props) {
    if (props.vendorId) return props.vendorId;
    if (props.item && props.item.vendor) return props.item.vendor.id;
    if (props.vendor) return props.vendor.id;
    return null;
}

class ReviewCreator extends React.Component {
    constructor(props) {
        super(props);

        const firstItemId = props.items && props.items.length > 0 ? props.items[0].id : null;
        this.state = {
            itemReviewText: "",
            itemReviewRating: 0,
            photos: [],
            eatenDate: new Date(),
            selectedItemId: firstItemId,
        };
    }

    resolveItemId() {
        if (this.props.itemId) return this.props.itemId;
        if (this.props.item) return this.props.item.id;
        return this.state.selectedItemId;
    }

    async publishItemReview(event) {
        event.preventDefault();
        try {
            await api.createReview({
                reviewableItemId: this.resolveItemId(),
                vendorId: resolveVendorId(this.props),
                rating: this.state.itemReviewRating,
                reviewText: this.state.itemReviewText,
                photos: this.state.photos,
                eatenAt: this.state.eatenDate.toISOString(),
                isDraft: false,
            });
            this.props.onReviewCompleted();
        } catch (err) {
            console.warn("Failed to publish review", err);
        }
    }

    async handleCancel(event) {
        event.preventDefault();
        this.props.onReviewCompleted();
    }

    async handleShareImageConfirm(photoKey) {
        if (!this.state.draftId) return;
        const photo = { key: photoKey, width: 0, height: 0 };
        const photos = [...this.state.photos, photo];
        this.setState({ photos });
        try {
            await api.updateReview(this.state.draftId, { photos });
        } catch (err) {
            console.warn("Failed to attach photo to draft", err);
        }
    }

    async updateItemReviewText(event) {
        event.preventDefault();
        this.setState({ itemReviewText: event.target.value });
    }

    async updateItemReviewRating(newRating) {
        this.setState({ itemReviewRating: newRating });
    }

    getImageMap(photos) {
        return photos.map(photo =>
            <ListGroup.Item key={photo.key} style={{display: "inline-block", border: "none"}}>
                <Image src={getCloudinaryUrlFromKey(photo.key, 400)} />
            </ListGroup.Item>
        );
    }
    getImages() {
        if(!this.state.photos || this.state.photos.length === 0) {
            return <Fragment></Fragment>;
        }
        return (
            <Fragment>
                <ListGroup>{this.getImageMap(this.state.photos)}</ListGroup>
            </Fragment>
        );
    }

    async updateItemEatenDate(date) {
        this.setState({ eatenDate: date });
    }

    renderItemSelector() {
        const { items, item, itemId } = this.props;
        if (item || itemId || !items || items.length === 0) return null;
        return (
            <Fragment>
                <Form.Label>Which doughnut?</Form.Label>
                <Form.Control
                    as="select"
                    value={this.state.selectedItemId || ""}
                    onChange={e => this.setState({ selectedItemId: e.target.value })}>
                    {items.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                </Form.Control>
                <Spacer height="12px" />
            </Fragment>
        );
    }

    render() {
        const itemName = this.props.item ? this.props.item.name : "doughnut";
        const vendorName = this.props.item && this.props.item.vendor ? this.props.item.vendor.name : "";
        return (
            <Fragment>
                <div style={{ padding: "24px 12px 24px 12px", marginTop: "0px", marginBottom: "0px" }}>
                    <h2>I ate a {itemName}</h2>
                    <h6>from {vendorName}</h6>
                    <Form
                        noValidate
                        onSubmit={e => this.publishItemReview(e)}>
                        <Form.Group>
                            <Spacer height="12px" />
                            {this.renderItemSelector()}
                            <ReviewRater onChange={this.updateItemReviewRating.bind(this)}></ReviewRater>
                            <Spacer height="12px"></Spacer>
                            <div className="headerTextLight">
                                <div style={{display: "inline-block"}}>on</div>
                                <div style={{display: "inline-block", marginLeft: "12px"}}>
                                    <DatePicker selected={this.state.eatenDate} onChange={this.updateItemEatenDate.bind(this)} />
                                </div>
                            </div>
                            <Spacer height="12px" />
                            <S3ImageUpload handleShareImageConfirm={this.handleShareImageConfirm.bind(this)}/>
                            <Spacer height="12px" />
                            <textarea id="review" placeholder="Add a review..." name="text" rows="10" cols="57" wrap="soft"
                                value={this.state.itemReviewText} onChange={this.updateItemReviewText.bind(this)}></textarea>
                            <br></br>
                            <div>
                                <Spacer height="24px" />
                                {this.getImages()}
                                <Button variant="primary" type="submit" style={{ float: "right", marginLeft: "6px"}}>
                                    Create
                                </Button>
                                <Button variant="secondary" style={{ float: "right"}} onClick={this.handleCancel.bind(this)}>
                                    Cancel
                                </Button>
                            </div>
                        </Form.Group>
                    </Form>
                </div>
            </Fragment>
        );
    }
}

export { ReviewCreator };
